var render, staticRenderFns
import script from "./InspectionCostPageQuick.vue?vue&type=script&lang=ts&"
export * from "./InspectionCostPageQuick.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionCostPageQuick.vue?vue&type=style&index=0&id=5ae05a4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae05a4d",
  null
  
)

export default component.exports